module HomePageModel

open Shared
open Model
open Elmish
open Elmish.Bridge
open ContractPageModel

type Model =
  { SearchValue: string option
    ContractProfitFades: Map<ContractId, ContractProfitFade option>
    ContractHomePageBuckets: Map<ContractId, ContractARBucket>
    VisitedContracts: ContractId list }

type Msg =
  | SearchboxChanged of string option
  | ContractProfitFade of ContractId * ContractProfitFade option
  | ContractProfitFades of (ContractId * ContractProfitFade option) list
  | ContractHomePageBuckets of (ContractId * ContractARBucket) list
  | ContractClicked of ContractId * Tab
  | RemoveVisitedContract of ContractId

let init () =
  { SearchValue = None
    ContractProfitFades = Map.empty
    ContractHomePageBuckets = Map.empty
    VisitedContracts = [] },
  Cmd.none

let update msg model =
  match msg with
  | SearchboxChanged value -> { model with SearchValue = value }, Cmd.none
  | ContractProfitFade (contractId, profitFade) ->
    { model with ContractProfitFades = Map.add contractId profitFade model.ContractProfitFades }, Cmd.none
  | ContractProfitFades profitFades ->
    { model with
        ContractProfitFades =
          List.fold
            (fun fades (contractId, fade) -> Map.add contractId fade fades)
            model.ContractProfitFades
            profitFades },
    Cmd.none
  | ContractHomePageBuckets buckets ->
    { model with
        ContractHomePageBuckets =
          List.fold
            (fun buckets (contractId, bucket) -> Map.add contractId bucket buckets)
            model.ContractHomePageBuckets
            buckets },
    Cmd.none
  | ContractClicked _ -> model, Cmd.none
  | RemoveVisitedContract contractId ->
    { model with
        VisitedContracts =
          model.VisitedContracts
          |> List.filter (fun id -> id <> contractId) },
    Cmd.none
